import classNames from 'classnames';
import {FullImageSwiper} from 'features/modal-swiper';
import {useFullImageSwiper} from 'features/modal-swiper/lib/useFullImageSwiper';
import {getImagesUrlsFromVariant} from 'features/product/lib/getImagesUrl';
import {useMatchMedia} from 'shared/lib/hooks/useMatchMedia';
import styles from './styles.module.scss';
import Image from 'next/image';
import {Image as IImage} from '../../../src/models/IImage';
import React, {FC, useMemo} from 'react';


interface IProps {
    images: IImage[];
}

export const ProductRealImages: FC<IProps> = ({images}) => {
    const realImages = getImagesUrlsFromVariant(images, 'small_webp', 'small');
    const thumbsImages = getImagesUrlsFromVariant(images, 'small_webp', 'small');
    const originalImages = getImagesUrlsFromVariant(images, 'original', 'large');
    const isMobile = useMatchMedia(767);
    const maxImages = isMobile ? 6 : 7;
    const moreImages = realImages.length - maxImages;
    const {isFullScreen, handleClose, handleClick, isActive, currentSlide} = useFullImageSwiper();

    const renderRealImagesList = useMemo(() => {
        return realImages.slice(0, maxImages).map((image, index) => {
            if (index === (maxImages - 1) && realImages.length > maxImages) {
                return (
                    <div className={classNames(styles.realImageContainer, styles.realImageBlur)} onClick={() => handleClick(0)}>
                        <Image
                            width={image.meta.width}
                            height={image.meta.height}
                            alt="Изображение продукта"
                            src={image.url}
                        />
                        <span className={styles.imagesNumber}>+{moreImages}</span>
                    </div>
                )
            }

            return (
                <div className={styles.realImageContainer} onClick={() => handleClick(index)}>
                    <Image
                        width={image.meta.width}
                        height={image.meta.height}
                        alt="Изображение продукта"
                        src={image.url}
                    />
                </div>
            )
        })
    }, [realImages])

    return (
        <>
            <div className={styles.imagesTitle}>Фотографии покупателей</div>
            <div className={styles.imagesContainer}>
                {renderRealImagesList}
            </div>
            {isFullScreen && !!images?.length && (
                <FullImageSwiper
                    onClose={handleClose}
                    images={originalImages}
                    isOpen={isActive}
                    thumbsImages={thumbsImages}
                    currentSlide={currentSlide}
                />
            )}
        </>
    )
}